//
import UsagiMouse from './class/class-mouse.js';
// import UsafiMouseTrail from './class/class-mouse-trail.js';

//
window.styleMouse = {
	ease : [0.075,0.1,0.2],
	once(){
		if( DETECT.reduced ) this.ease = [1,1];
		this.body = new UsagiMouse({
			ease : this.ease,
			onUpdateAfter : () =>{
				DEV.onMouseMove();
			}
		});
	}
}

styleMouse.once();